import { useQuery } from '@tanstack/react-query'
import { axiosClient } from 'api/apiClient'
import { env } from 'utils'

import { ServerSpaceMetadata, serverSpaceMetadataSchema } from '../schema/spaceMetadata.schema'

export const spaceMetadataQueryKey = (spaceAddress: string | undefined) =>
    ['spaceMetadata', spaceAddress ?? 'unknown'] as const

export const useFetchSpaceMetadata = (
    spaceAddress: string | undefined,
    options?: { enabled?: boolean },
) => {
    const { enabled = true } = options ?? {}

    return useQuery<ServerSpaceMetadata | undefined, Error>({
        queryKey: spaceMetadataQueryKey(spaceAddress),
        queryFn: async () => {
            if (!spaceAddress) {
                throw new Error('space address is required to fetch town metadata')
            }

            const response = await axiosClient.get(
                `${env.VITE_GATEWAY_URL}/space/${spaceAddress}/metadata`,
                {
                    withCredentials: true,
                },
            )

            return serverSpaceMetadataSchema.parse(response.data)
        },
        enabled: enabled && Boolean(spaceAddress),
    })
}
